import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';
import uploadCampaignList from './modules/UploadCampaignList';
import sendTest from './modules/SendCampaignTest';
import sendCampaign from './modules/SendCampaign';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}
interface IParams {
  projectHash: string;
  eventHash: string;
}


const MailerCampaign: React.FC = () => {
  const endpoint = '/mailer-campaign';
  const title = 'Campanha';

  const { projectHash, eventHash } = useParams<Record<string, any>>();


  const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID' },
    project_id: { ref: 'project_id', column: 'project_id', label: 'Projeto', show: false },
    title: { ref: 'title', column: 'title', label: 'Título' },
    reply_to: { ref: 'reply_to', column: 'reply_to', label: 'Responder para:' },
    mail_type: { ref: 'mail_type', column: 'mail_type', label: 'Tipo' },
    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {
    title: { model: 'input', type: 'text', name: 'title', label: 'Título do e-mail' },
    reply_to: { model: 'input', type: 'text', name: 'reply_to', label: 'Responder para:' },
    start_at: { model: 'datePickerHour', type: 'text', name: 'start_at', label: 'Data de envio' },

    product_confirmation_id: {
      alias: 'product_confirmation_id',
      model: 'input',
      name: 'product_confirmation_id',
      label: 'Produto',

    },

    active: {
      label: 'A campanha está ativa?',
      name: 'active',
      model: 'selectSimple',
      options: [

        { label: 'Sim', value: 'Sim' },
        { label: 'Não', value: 'Não' },


      ]
    },


    update_fields: {
      model: 'jsonInputList',
      type: 'text',
      name: 'update_fields',
      label: 'Campos',
      show: ['title'],
      list: [
        { label: 'Título do campo', name: 'label', type: 'input' },
        {
          label: 'Campo', name: 'value', type: 'select', options: [
            { label: 'Nome', value: 'name' },
            { label: 'CPF', value: 'document_number' },
            { label: 'CNPJ', value: 'company_document_number' },
            { label: 'Empresa', value: 'company' },
            { label: 'Cargo / Profissão', value: 'position' },

          ]
        },

      ]
    },

    update_fields_check_by: {
      label: 'Validar a atualização pela existência do campo:',
      name: 'update_fields_check_by',
      model: 'selectSimple',
      options: [

        { label: 'CPF', value: 'document_number' },
        { label: 'CNPJ', value: 'company_document_number' },
        { label: 'Empresa', value: 'company' },
        { label: 'Cargo / Profissão', value: 'position' },

      ]
    },

    header: {
      model: 'singleImage',

      name: 'header',
      label: 'Cabeçalho',
      list: [
        { label: 'Imagem', name: 'url', type: 'input' },

      ],
    },

    description: { model: 'richText', type: 'text', name: 'description', label: 'Texto de abertura' },


    footer: {
      model: 'singleImage',

      name: 'footer',
      label: 'Rodapé',
      list: [
        { label: 'Imagem', name: 'url', type: 'input' },

      ],
    },

    mail_type: {
      model: 'selectSimple',

      name: 'mail_type',
      label: 'Tipo de e-mail',
      options: [
        { label: 'Padrão', value: 'Padrão' },
        { label: 'Confirmação', value: 'Confirmação' },
        { label: 'Atualização cadastral', value: 'Atualização' },
      ],
    },


  };

  const formSchemaUpdate = {

    ...formSchema



  };

  const formValidation: Record<string, ValidationSchema> = {

  };

  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,

        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,

        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,

        }),

      (lineData: Record<string, any>) =>
        sendTest({
          lineData,
          projectHash,


        }),
      (lineData: Record<string, any>) =>
        sendCampaign({
          lineData,
          projectHash


        }),


    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default MailerCampaign;
